import React from 'react'
import { Helmet } from 'react-helmet'

import '../css/Donate.css'

export default function Donate() {
  return (
    <div id="donate">
      <Helmet>
        <title>Donate - Enoho Fikir</title>
      </Helmet>

      <h1>Donate</h1>
    </div>
  )
}